import { DefaultNodeModel } from "@projectstorm/react-diagrams";
import { v4 as uuidv4 } from "uuid";
import { FunctionMap } from "../NodeFunctions";

export class FunctionNodeModel extends DefaultNodeModel {
  constructor({
    id = `FunctionNode_${uuidv4()}`,
    color = "rgb(42, 189, 192)",
    position = { x: 100, y: 100 },
    nodeProperties = { Name: "New Function", Type: "Function", Function: "" },
  }) {
    super({
      id: id,
      name: nodeProperties.Name,
      color: color,
      extras: { properties: nodeProperties },
    });
    this.setPosition(position.x, position.y);

    if (nodeProperties.Function) {
      const scope = FunctionMap.find((item) => item.Name === nodeProperties.Function).Scope;
      scope.forEach((item) => {
        this.addInPort(item);
      });
    }

    this.addOutPort("evaluate");
  }
}
